import { type FormBase } from "./baseTypes";

export type DirectorFormShareholders = Record<string, string>;

export enum NatureOfControl {
  AppointRemoveDirectors = "AppointRemoveDirectors",
  SignificantInfluenceOrControl = "SignificantInfluenceOrControl",
}

interface PscStatus {
  isSignificant: boolean;
  hasRightToAppoint: boolean;
  hasSignificantControl: boolean;
}

export function determinePscStatus(
  sharesNum: number,
  totalSharesNum: number,
  natureOfControl: NatureOfControl[],
): PscStatus {
  const ownershipPercent = totalSharesNum > 0 ? (sharesNum / totalSharesNum) * 100 : 0;
  const isAutomatic = ownershipPercent >= 25;
  const hasNatureOfControl = natureOfControl.length > 0;

  return {
    isSignificant: isAutomatic || hasNatureOfControl,
    hasRightToAppoint: natureOfControl.includes(NatureOfControl.AppointRemoveDirectors),
    hasSignificantControl: natureOfControl.includes(NatureOfControl.SignificantInfluenceOrControl),
  };
}

export interface ParticularsFormValues extends FormBase {
  totalShares: string;
  shareValue: string;
  sharesManagement?: boolean;
  totalCapital: string;
  directors: DirectorFormShareholders;
  directorsSignificantControl: DirectorFormShareholders;
  directorsNatureOfControl?: Record<string, NatureOfControl[]>;
  pscConfirmation?: boolean;
}

export interface ConfirmAppointmentsFormValues extends FormBase {
  directorsNatureOfControl: Record<string, NatureOfControl[]>;
  pscConfirmation: boolean;
}
